{
  "notificationPage": {
    "conflict": {
      "resolvedCi": "Разрешённый CI конфликт",
      "attributes": "Атрибуты",
      "deletedCis": "Список удалённых CI",
      "createdLinks": "Список созданных связей",
      "deletedLinks": "Список удалённых связей"
    }
  },
  "notificationView": {
    "badFormat": "Некорректный формат оповещения",
    "table": {
      "created_at": "Время",
      "body": "Сообщение"
    }
  }
}